var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useState, useMemo } from 'react';
import Color from '@src/utils/color';
import { failContrast } from '../sdk';
export function getStatus(contrast) {
  var level;
  var levelLarge;
  var normalFail = false;
  var largeFail = false;
  if (contrast >= 7) {
    level = 'AAA';
    levelLarge = 'AAA';
  } else if (contrast >= 4.5) {
    level = 'AA';
    levelLarge = 'AAA';
  } else if (contrast >= 3) {
    level = '未通过';
    normalFail = true;
    levelLarge = 'AA';
  } else {
    level = '未通过';
    levelLarge = '未通过';
    normalFail = true;
    largeFail = true;
  }
  return {
    level: level,
    levelLarge: levelLarge,
    normalFail: normalFail,
    largeFail: largeFail
  };
}
export var defaultFrontColor = '#ffffff';
export var defaultBackgroundColor = '#4E5969';
export function getColor(color, defaultColor) {
  try {
    return Color(color);
  } catch (e) {
    return Color(defaultColor);
  }
}
export var getFrontColor = function getFrontColor(background) {
  return failContrast(background) ? '#4E5969' : defaultFrontColor;
};
export default function useWcag(props) {
  var _a = __read(useState(getFrontColor(props.background)), 2),
    front = _a[0],
    setFront = _a[1];
  var _b = __read(useState(props.background || defaultBackgroundColor), 2),
    background = _b[0],
    setBackground = _b[1];
  var contrast = useMemo(function () {
    var backgroundObj = getColor(background, defaultBackgroundColor);
    var frontObj = getColor(front, defaultFrontColor);
    return backgroundObj.contrast(frontObj).toFixed(2);
  }, [background, front]);
  var status = getStatus(contrast);
  var level = status.level,
    levelLarge = status.levelLarge,
    largeFail = status.largeFail,
    normalFail = status.normalFail;
  return {
    front: front,
    background: background,
    level: level,
    levelLarge: levelLarge,
    largeFail: largeFail,
    normalFail: normalFail,
    setFront: setFront,
    setBackground: setBackground,
    contrast: contrast
  };
}